// Direct SVG paths from public folder
const aquarium = './assets/lixo/aquario.svg'
const bucket = './assets/lixo/balde.svg'
const bus = './assets/lixo/brinquedo_onibus.svg'
const robot = './assets/lixo/brinquedo_robo.svg'
const caixaPapelao = './assets/lixo/caixa_papelao.svg'
const pizzabox = './assets/lixo/caixa_pizza.svg'
const milkbox = './assets/lixo/caixinha_leite.svg'
const oldShirt = './assets/lixo/camisa_velha.svg'
const cascaBanana = './assets/lixo/casca_banana.svg'
const cellphone = './assets/lixo/celular.svg'
// Vermelho (Plástico / Têxtil)
const garrafaPet = './assets/lixo/garrafa_pet.svg'
const garrafaVidro = './assets/lixo/garrafa_vidro.svg'
const lataConservas = './assets/lixo/lata_conservas.svg'
// Amarelo (Metal)
const lataRefrigerante = './assets/lixo/lata_refrigerante.svg'
const paintCan = './assets/lixo/lata_tinta.svg'
const maca = './assets/lixo/maca.svg'
const watermelon = './assets/lixo/melancia.svg'
// Azul (Papel)
const papel = './assets/lixo/papel.svg'
const paperCrumpled = './assets/lixo/papel_amassado.svg'
const toothpaste = './assets/lixo/pasta_dente.svg'
const softener = './assets/lixo/pote_amaciante.svg'
// Verde (Vidro)
const poteVidro = './assets/lixo/pote_vidro.svg'
const trashBag = './assets/lixo/saco_lixo.svg'
// Marrom (Orgânico)
const stem = './assets/lixo/tronco.svg'
const plantPot = './assets/lixo/vaso_planta.svg'

const trashTypes = [
	// PAPEL (azul) - 10 pontos
	{ id: 'paper', icon: papel, bin: 'blue', points: 10 },
	{ id: 'paper2', icon: caixaPapelao, bin: 'blue', points: 10 },
	{ id: 'pizzabox', icon: pizzabox, bin: 'blue', points: 10 },
	{ id: 'milkbox', icon: milkbox, bin: 'blue', points: 10 },
	{ id: 'paper_crumpled', icon: paperCrumpled, bin: 'blue', points: 10 },

	// VIDRO (verde) - 15 pontos
	{ id: 'glass', icon: poteVidro, bin: 'green', points: 15 },
	{ id: 'aquarium', icon: aquarium, bin: 'green', points: 15 },
	{ id: 'glass_bottle', icon: garrafaVidro, bin: 'green', points: 15 },

	// PLÁSTICO (vermelho) - 10 pontos
	{ id: 'plastic', icon: garrafaPet, bin: 'red', points: 10 },
	{ id: 'bus', icon: bus, bin: 'red', points: 10 },
	{ id: 'softener', icon: softener, bin: 'red', points: 10 },
	{ id: 'toothpaste', icon: toothpaste, bin: 'red', points: 10 },
	{ id: 'robot', icon: robot, bin: 'red', points: 10 },
	{ id: 'plant_pot', icon: plantPot, bin: 'red', points: 10 },
	{ id: 'trash_bag', icon: trashBag, bin: 'red', points: 10 },

	// METAL (amarelo) - 20 pontos
	{ id: 'metal', icon: lataRefrigerante, bin: 'yellow', points: 20 },
	{ id: 'metal2', icon: lataConservas, bin: 'yellow', points: 20 },
	{ id: 'bucket', icon: bucket, bin: 'yellow', points: 20 },
	{ id: 'paint_can', icon: paintCan, bin: 'yellow', points: 20 },
	{ id: 'cellphone', icon: cellphone, bin: 'yellow', points: 20 },

	// ORGÂNICO (marrom) - 5 pontos
	{ id: 'stem', icon: stem, bin: 'brown', points: 5 },
	{ id: 'watermelon', icon: watermelon, bin: 'brown', points: 5 },
	{ id: 'banana', icon: cascaBanana, bin: 'brown', points: 5 },
	{ id: 'apple', icon: maca, bin: 'brown', points: 5 },

	// TÊXTIL (vermelho - não reciclável comum)
	{ id: 'old_shirt', icon: oldShirt, bin: 'red', points: 10 },
]

const bins = [
	{ id: 'blue', color: 'bg-blue-500', label: 'Papel' },
	{ id: 'green', color: 'bg-green-500', label: 'Vidro' },
	{ id: 'red', color: 'bg-red-500', label: 'Plástico' },
	{ id: 'yellow', color: 'bg-yellow-500', label: 'Metal' },
	{ id: 'brown', color: 'bg-amber-700', label: 'Orgânico' },
]

interface Trash {
	id: string
	icon: string
	bin: string
	points: number
	y: number
}

interface Bin {
	id: string
	color: string
	label: string
}

interface GameData {
	score: number
	lives: number
	matchTime: number
}

interface Ranking {
	name: string
	matchTime: number
	date: string
	score: number
}

export { trashTypes, bins, type Trash, type Bin, type GameData, type Ranking }
